import { useMutation, useQueryClient } from 'react-query';
import { apiService } from '../../../../utils/api';
import { toast } from 'sonner';
import { useDispatch } from 'react-redux';
import { fetchDetail } from '@/store/actions/typemark';
import { DropdownMenuItem } from '@/components/ui/Dropdown';

type ChangeTypemarkStateMenuItemProps = {
  isActive: boolean;
  id: string;
};

const ChangeTypemarkStateMenuItem = ({ isActive, id }: ChangeTypemarkStateMenuItemProps) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const changeTypemarkState = useMutation({
    mutationFn: () => {
      return apiService.post(`/api/v1/instance-type/${isActive ? 'deactivate' : 'activate'}/`, {
        instance_type_ids: [id],
      });
    },
    onSuccess: () => {
      toast.success('Stav byl úspěšně změněn');
      queryClient.invalidateQueries('instance-type');

      dispatch(fetchDetail(id));
    },
  });

  return (
    <DropdownMenuItem
      data-testid="typemark-change-state-btn"
      onClick={() => changeTypemarkState.mutate()}
    >
      {isActive ? 'Deaktivovat' : 'Aktivovat'}
    </DropdownMenuItem>
  );
};

export default ChangeTypemarkStateMenuItem;
